<template>
  
  <div class="pdf">
    <div class="back">
      <div class="back-icon" @click="jump()"></div>
      <div class="title">人脸注册照片规范说明</div>
    </div>
    <pdf src="http://sc.geemi.cn/timeloit/webpage/wechat/static/test.pdf"></pdf>
  </div>
</template>

<script>
import pdf from 'vue-pdf'
export default{
  components: {
    pdf
  },
  methods: {
      jump:function(){
          this.$router.push({
            path: "/"
          });
      }
  }
}
</script>
<style lang="scss">
.back{
    width:100%;
    height:.8rem;
    padding:0 .2rem;
    position:relative;
    .back-icon{
        position:absolute;
        top:.24rem;
        left:.2rem;
        width:.18rem;
        height:.32rem;
        background:url("../../assets/images/fanhuik.png") no-repeat center center;
        background-size:100% 100%;
    }
    .title{
        width:100%;
        text-align:center;
        line-height:.8rem;
        font-size:.32rem;
    }
}

</style>


// WEBPACK FOOTER //
// src/components/pdf/index.vue